// extracted by mini-css-extract-plugin
module.exports =  {"CooldownDisplay":"C8ZqOwcgLK68wz3IxjZ5","CooldownDisplay__Message":"WVHWKsOek8Rh3Iv3fz17"};